import React, { useState, useEffect } from "react";
import "./AboutUsCredentials.css";
import { Image, Stack } from "react-bootstrap";
import { map } from "lodash";

import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";

import { handleContactRedirect } from "../../handleContactRedirect";
import { useNavigate } from "react-router-dom";

export const AboutUsCredentials = ({ desc, data }) => {
  const [windowWidth, setWindowWidth] = useState(900);
  const navigate = useNavigate();

  useEffect(() => {
    if (typeof window !== "undefined") {
      setWindowWidth(window.innerWidth);

      const handleResize = () => setWindowWidth(window.innerWidth);

      window.addEventListener("resize", handleResize);

      return () => window.removeEventListener("resize", handleResize);
    }
  }, []);

  return (
    <div className="AboutUsCredentials standard-padding">
      <h1 className="heading mb-4">{desc}</h1>

      {windowWidth > 900 ? (
        /* DESKTOP VIEW */
        <Stack direction="horizontal" className="AboutUsCredentials-container">
          {map(data, (d, index) => (
            <div key={index} className="AboutUsCredentials-card">
              <div className="AboutUsCredentials-card-container">
                <Image
                  className="AboutUsCredentials-card-img"
                  src={d.image}
                  alt="about-card-img"
                />

                <p className="AboutUsCredentials-card-text">{d.title}</p>

                <p className="AboutUsCredentials-card-text2">{d.desc}</p>
              </div>
            </div>
          ))}

          <div
            onClick={() => handleContactRedirect(navigate)}
            style={{ textDecoration: "none", cursor: "pointer" }}
            className="AboutUsCredentials-card AboutUsCredentials-card-a"
          >
            <div
              className="AboutUsCredentials-card w-100"
              style={{
                backgroundColor: "rgba(19, 70, 133, 1)",
                cursor: "pointer",
              }}
            >
              <div className="AboutUsCredentials-card-container justify-content-center">
                <Image
                  className="AboutUsCredentials-card-img1"
                  src="/assets/about-credential-arrow.png"
                  alt="about-card-img"
                />

                <p className="AboutUsCredentials-card-text1">
                  Request for Proposals
                </p>
              </div>
            </div>
          </div>
        </Stack>
      ) : (
        /* MOBILE / TABLET VIEW */
        <div className="mobile-credentials-wrapper">
          <Swiper
            modules={[Pagination, Autoplay]}
            spaceBetween={16}
            slidesPerView={1}
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
            }}
            pagination={{
              clickable: true,
            }}
            breakpoints={{
              0: {
                slidesPerView: 1,
              },
              600: {
                slidesPerView: 2,
              },
            }}
            className="AboutUsCredentials-slider"
          >
            {map(data, (d, index) => (
              <SwiperSlide key={index}>
                <div className="AboutUsCredentials-card">
                  <div className="AboutUsCredentials-card-container">
                    <Image
                      className="AboutUsCredentials-card-img"
                      src={d.image}
                      alt="about-card-img"
                    />

                    <p className="AboutUsCredentials-card-text">{d.title}</p>

                    <p className="AboutUsCredentials-card-text2">{d.desc}</p>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          {/* STATIC BUTTON BELOW SLIDER FOR MOBILE */}
          <button
            className="mobile-rfp-btn"
            onClick={() => handleContactRedirect(navigate)}
          >
            <Image
              className="mobile-rfp-btn-icon"
              src="/assets/about-credential-arrow.png"
              alt="request-icon"
            />
            <span>Request for Proposals</span>
          </button>
        </div>
      )}
    </div>
  );
};